import { render, staticRenderFns } from "./AssignContractData.vue?vue&type=template&id=1c4f1e5d&scoped=true"
import script from "./AssignContractData.vue?vue&type=script&lang=js"
export * from "./AssignContractData.vue?vue&type=script&lang=js"
import style0 from "./AssignContractData.vue?vue&type=style&index=0&id=1c4f1e5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4f1e5d",
  null
  
)

export default component.exports